import axios from "axios";
import { getAuthHeader } from "../utils/AuthUtils";
import {
  ProjectArtwork,
  GroupedAssetToProject,
  Response,
  UserLogo,
} from "../types";
const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_ROUTE = "/api/v1/assets";

class AssetService {
  static async getAllProjectsArtworksByTeamId(teamId: string) {
    return axios.get<Response<GroupedAssetToProject>>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/team/${teamId}`,
      getAuthHeader()
    );
  }

  static async getRecentsArtworks(teamId: string) {
    return axios.get<Response<ProjectArtwork[]>>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/team/${teamId}/recent`,
      getAuthHeader()
    );
  }

  static async uploadTeamLogo(
    teamId: string,
    imageData: string,
    fileName: string
  ) {
    return axios.post<Response<{ logoId: string; url: string }>>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/team/${teamId}/logo`,
      { imageData, fileName },
      getAuthHeader()
    );
  }

  static async getTeamLogos(teamId: string) {
    return axios.get<Response<UserLogo[]>>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/team/${teamId}/logos`,
      getAuthHeader()
    );
  }

  static async deleteTeamLogo(teamId: string, logoId: string) {
    return axios.delete<Response<{ message: string; logoId: string }>>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/team/${teamId}/logo/${logoId}`,
      getAuthHeader()
    );
  }
}
export default AssetService;
